import React from 'react';
import { colors } from '@utils/constants';

type Props = {
  type: 'info' | 'warning' | 'error';
};

const svgColor: Record<
  Props['type'],
  {
    rectFill: string;
    rectStroke: string;
    pathStroke: string;
  }
> = {
  warning: {
    rectFill: colors.warning[100],
    rectStroke: colors.warning[50],
    pathStroke: colors.warning[500]
  },
  info: {
    rectFill: colors.gray[100],
    rectStroke: colors.gray[50],
    pathStroke: colors.gray[500]
  },
  error: {
    rectFill: colors.error[100],
    rectStroke: colors.error[50],
    pathStroke: colors.error[500]
  }
};

const InfoCircleIcon: React.FC<Partial<Props>> = ({ type = 'warning' }) => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="48" height="48" rx="24" fill={svgColor[type].rectFill} />
    <rect x="4" y="4" width="48" height="48" rx="24" stroke={svgColor[type].rectStroke} strokeWidth="8" />
    <path
      d="M28 24V28M28 32H28.01M38 28C38 33.5228 33.5228 38 28 38C22.4772 38 18 33.5228 18 28C18 22.4772 22.4772 18 28 18C33.5228 18 38 22.4772 38 28Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={svgColor[type].pathStroke}
    />
  </svg>
);

export default InfoCircleIcon;
